import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect, useState } from "react";
import { FaCartPlus, FaHome, FaList } from "react-icons/fa";
import { BsArrowLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

export const AppBar = () => {
  const { setAppBar, appBar } = useThemeStore((state) => state);
  const [show, setShow] = useState<boolean>(false);

  const navigate = useNavigate();

  const handleScroll = () => {
    const position = window.scrollY;
    setShow(position > 35);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setAppBar({ ...appBar, checkout: false, shopList: false });
  }, []);

  const handleLeading = () => {
    if (appBar.leading === "back") {
      navigate(-1);
    } else {
      navigate(linkPage.HOME_DASHBOARD, { replace: true });
    }
  };

  return (
    <div
      className={`header header-auto-show tw-flex tw-items-center tw-justify-between tw-text-text-primary tw-px-4 tw-bg-background-200 ${
        (show || appBar.fixed) && "header-active"
      }`}
    >
      <div
        className="tw-flex tw-items-center header-icon header-icon-1"
        onClick={handleLeading}
      >
        {appBar.leading === "home" ? (
          <FaHome size={16} />
        ) : (
          <BsArrowLeft size={18} />
        )}
        <div className="header-title tw-ms-4">{appBar.title}</div>
      </div>
      {(appBar.actions ?? []).map((action) => action)}
      <div className="tw-text-text-primary">
        <>
          {appBar.checkout && (
            <FaCartPlus
              size={20}
              className={`${appBar.shopList && "tw-mr-4"}`}
              onClick={() => navigate(linkPage.MARKETPLACE_CHECKOUT)}
            />
          )}
          {appBar.shopList && (
            <FaList
              size={20}
              onClick={() => navigate(linkPage.MARKETPLACE_HISTORY)}
            />
          )}
        </>
      </div>
    </div>
  );
};
